<template>
  <div class="viewing-discipline-preview">
    <h4>Просмотр</h4>
    <ul class="preview-list">
      <li class="preview-item">
        <tree-item
          ref="itemTree"
          :readOnly="true"
          draggable="true"
          class="discipline-item"
          :item="treeDataMaterial"
        />
      </li>
      <li>
        <div class="preview-item__title" @click="showVideo = !showVideo">
          <i class="fas fa-film"></i>
          <span>Видео</span>
        </div>
        <ul class="preview-item__list" v-if="showVideo">
          <li
            class="preview-item__title"
            v-for="(video, index) of treeDataMaterial.videos"
            :key="index"
          >
            <i class="fas fa-film"></i>
            <a :href="video.url" target="blank">{{ video.name }}</a>
          </li>
          <li v-if="emptyVideo">
            <span>Содержимое отсутствует</span>
          </li>
        </ul>
      </li>
      <li>
        <div class="preview-item__title" @click="showVebinar = !showVebinar">
          <i class="fas fa-video"></i>
          <span>Вебинары</span>
        </div>
        <ul class="preview-item__list" v-if="showVebinar">
          <li
            v-for="(vebinar, index) of treeDataMaterial.webinars"
            :key="index"
          >
            <a class="preview-item__title" target="blank" :href="vebinar.url">
              <i class="fas fa-video"></i>
              <span>Вебинар</span>
              <span>{{ vebinar.date }}</span>
            </a>
          </li>
          <li v-if="emptyWebinar">
            <span>Содержимое отсутствует</span>
          </li>
        </ul>
      </li>
      <li>
        <div class="preview-item__title" @click="showTest = !showTest">
          <i class="fas fa-question"></i>
          <span>Тесты</span>
        </div>
        <ul class="preview-item__list" v-if="showTest">
          <li v-if="emptyTests(treeDataMaterial.tests)">
            <div v-if="treeDataMaterial.tests.oud" class="preview-item__group">
              <span>Тесты ОУД</span>
              <li
                class="preview-item__title"
                @click="openTest(test)"
                v-for="(test, index) of treeDataMaterial.tests.oud"
                :key="index"
              >
                <i class="fas fa-question"></i>
                <span>{{ test.name }}</span>
              </li>
            </div>
            <div
              v-if="treeDataMaterial.tests.notOud"
              class="preview-item__group"
            >
              <span> Тесты</span>
              <li
                class="preview-item__title"
                @click="openTest(test)"
                v-for="(test, index) of treeDataMaterial.tests.notOud"
                :key="index"
              >
                <i class="fas fa-question"></i>
                <span>{{ test.name }}</span>
              </li>
            </div>
          </li>

          <li v-else>
            <span>Содержимое отсутствует</span>
          </li>
        </ul>
      </li>
    </ul>
    <transition name="fade">
      <html-editor
        :defaultValue="selectedElementBody"
        :readOnly="true"
        :pathToFile="selectedElement.path"
        class="html-editor-window"
        v-if="htmlEditorActive"
      />
    </transition>
  </div>
</template>

<script>
import htmlEditor from "../htmlEditor/App";
import treeItem from "../viewingDiscipline/itemTree";
import { mapMutations } from "vuex";
export default {
  name: "viewingPreview",
  data() {
    return {
      showVebinar: true,
      showVideo: true,
      showTest: true,
      treeDataMaterial: {},
    };
  },
  components: {
    "tree-item": treeItem,
    "html-editor": htmlEditor,
  },
  computed: {
    htmlEditorActive() {
      return this.$store.state.viewingDiscipline.htmlEditorActive;
    },
    selectedElement() {
      return this.$store.state.viewingDiscipline.selectedItem;
    },
    selectedElementBody() {
      return this.selectedElement ? this.selectedElement.body : "";
    },
    emptyVideo() {
      if (this.treeDataMaterial.videos) {
        return this.treeDataMaterial.videos.length ? false : true;
      }
      return false;
    },
    emptyWebinar() {
      if (this.treeDataMaterial.webinars) {
        return this.treeDataMaterial.webinars.length ? false : true;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations(["setBlockScroll", "setSelectedItem"]),
    openTest(value) {
      this.$store.commit("setSettingTest", value);
      this.$emit("change", { tab: "viewingDisciplineTests" });
    },
    emptyTests(value) {
      if (value === null) return false;
      return !this.globalFunctions.isEmpty(value);
    },
  },
  mounted() {
    let dataMaterial = this.$store.state.viewingDiscipline.treeData;
    dataMaterial.lable = "Материалы";
    this.treeDataMaterial = dataMaterial;
    this.$refs.itemTree.isOpen = true;
  },
  beforeDestroy() {
    this.setSelectedItem(null);
  },
};
</script>

<style lang="scss">
.viewing-discipline-preview {
  color: $primary-text-clr;
  padding: 0 10px;
  overflow-y: auto;
  .preview-list {
    max-width: 600px;
    height: max-content;
  }
  li {
    list-style: none;
  }
  .preview-item__title {
    border-radius: 10px;
    margin: 5px 0;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    display: grid;
    grid-template-columns: 30px 1fr auto;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    &:hover {
      background-color: $extra-light-border;
    }
    i {
      transition-duration: 0.3s;
      transition-property: color;
      color: $brand-clr-1;
      font-size: 20px;
    }
  }
  .preview-item__list {
    padding-left: 3em;
    width: 100%;
  }
  .html-editor-window {
    padding: 0 10px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: $basic-white;
    z-index: 22;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }
}
@media screen and (max-width: 600px) {
  .viewing-discipline-preview {
    .preview-list {
      width: 100%;
    }
  }
}
</style>